import { Icon } from 'semantic-ui-react';
import CenterCell from './table/CenterCell';

function PassFailResult({ passed, skipped, flaky, center = true }) {
	let name, color = null;

	if(passed === 1) {
		name  = "check";
		color = "green";
	}
	else if(skipped === 1) {
		name  = "warning circle";
		color = "yellow";
	}
	else if(flaky === 1) {
		name  = "snowflake outline";
		color = "blue";
	}
	// Failed test
	else {
		name  = "cancel";
		color = "red";
	}

	return !center ? <Icon name={name} color={color} /> : <CenterCell><Icon name={name} color={color} /></CenterCell>
}

export default PassFailResult;
